import type { EnPracticeArea, EnPracticeMap } from "./en-types";
import { EN_PRACTICE_A } from "./en-a";
import { EN_PRACTICE_B } from "./en-b";

export const EN_PRACTICE: EnPracticeMap = { ...EN_PRACTICE_A, ...EN_PRACTICE_B };

export const EN_PRACTICE_LIST: EnPracticeArea[] = Object.values(EN_PRACTICE);

export function enPractice(slug: string): EnPracticeArea | undefined {
  return EN_PRACTICE[slug];
}

export type { EnPracticeArea };
